import { BuildingType } from "./building-type";

export interface Dimension {
  width: number;
  height: number;
  hideLowerBox?: boolean;
}

export interface BuildingConfig {
  buildingType: BuildingType;
  animationDelay: number;
  width: number;
  initialHeight: number;
  finalHeight: number;
  heightOffset: number;
  windowMargin: number;
  showBase: boolean;
  class?: string;
  routePath?: string;
  name?: string;
  key?: string;
}

const MarketplaceConfig: BuildingConfig = {
  buildingType: BuildingType.Marketplace,
  animationDelay: 0.5,
  initialHeight: 200,
  width: 400,
  finalHeight: 450,
  heightOffset: 150,
  windowMargin: 50,
  showBase: true,
  class: "marketplace",
  routePath: "marketplace",
  name: "Marketplace",
  key: "marketplace",
};

const WarehouseConfig: BuildingConfig = {
  buildingType: BuildingType.Warehouse,
  animationDelay: 2,
  initialHeight: 200,
  width: 400,
  finalHeight: 350,
  heightOffset: 120,
  windowMargin: 0,
  showBase: false,
  class: "warehouse",
  routePath: "service-matrix",
  name: "Service Matrix",
  key: "servicesMatrix"
};

const CatelogConfig: BuildingConfig = {
  buildingType: BuildingType.Catalog,
  animationDelay: 0,
  initialHeight: 200,
  width: 400,
  finalHeight: 600,
  heightOffset: 120,
  windowMargin: 50,
  showBase: false,
  class: "catalog",
  routePath: "catalog",
  name: "Catalog",
  key: "catalog"
};

const SpaceConfig: BuildingConfig = {
  buildingType: BuildingType.SpaceConfig,
  animationDelay: 0,
  initialHeight: 200,
  width: 400,
  finalHeight: 650,
  heightOffset: 120,
  windowMargin: 10,
  showBase: false,
  class: "space-config",
  routePath: "space-config",
  name: "Space Configurator",
  key: "spaceBot"
};

const MonitoringConfig: BuildingConfig = {
  buildingType: BuildingType.Monitoring_Reporting,
  animationDelay: 0,
  initialHeight: 200,
  width: 400,
  finalHeight: 350,
  heightOffset: 120,
  windowMargin: 10,
  showBase: true,
  class: "monitoring",
  routePath: "monitoring",
  name: "Monitoring & Reporting",
  key: "monitoring"
};

const TrackerConfig: BuildingConfig = {
  buildingType: BuildingType.Tracker,
  animationDelay: 0,
  initialHeight: 200,
  width: 400,
  finalHeight: 400,
  heightOffset: 120,
  windowMargin: 0,
  showBase: false,
  class: "tracker",
  routePath: "tracker",
  name: "Tracker",
  key: "tracker"
};

const ManagementConfig: BuildingConfig = {
  buildingType: BuildingType.Management,
  animationDelay: 0,
  initialHeight: 200,
  width: 400,
  finalHeight: 250,
  heightOffset: 120,
  windowMargin: 50,
  showBase: true,
  class: "management",
  routePath: "security",
  name: "Management",
  key: "management"
};

const LibraryConfig: BuildingConfig = {
  buildingType: BuildingType.Library,
  animationDelay: 0,
  initialHeight: 200,
  width: 500,
  finalHeight: 350,
  heightOffset: 150,
  windowMargin: 50,
  showBase: true,
  class: "library",
  routePath: "library",
  name: "Library",
  key: "library"
};

const DummyConfig: BuildingConfig = {
  buildingType: BuildingType.Dummy,
  animationDelay: 0,
  initialHeight: 200,
  width: 400,
  finalHeight: 300,
  heightOffset: 120,
  windowMargin: 50,
  class: "dummy",
  showBase: true,
};

export const configs = [
  MarketplaceConfig,
  CatelogConfig,
  WarehouseConfig,
  DummyConfig,
  SpaceConfig,
  TrackerConfig,
  MonitoringConfig,
  LibraryConfig,
  ManagementConfig,
];
